import { CTA } from '@volkswagen-onehub/components-core';
import { CTAButtonProps } from '@volkswagen-onehub/components-core/dist/call-to-action';
import { type ReactNode } from 'react';

interface CTAMailProps {
  mailto: string;
  children?: ReactNode;
  ctaProps?: Omit<CTAButtonProps, 'tag'>;
  onClick?: () => void;
}

const CTAMail = ({ mailto, children, ctaProps, onClick }: CTAMailProps) => (
  <CTA
    {...ctaProps}
    tag="a"
    href={`mailto:${mailto}`}
    onClick={onClick}
    data-testid="cta-mail"
  >
    {children || mailto}
  </CTA>
);

export default CTAMail;
